module.exports = __webpack_public_path__ + "static/media/muscle_front_5.b53a1023.png";